/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Description_Export_Event_Needs_RenderInputs */



/**
* | output |
* | --- |
* | "Event {index} needs to be rendered. The saved audio does not match the current text or voice. Would you like to ABORT your export?" |
*
* @param {Audio_Description_Export_Event_Needs_RenderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_event_needs_render = /** @type {((inputs: Audio_Description_Export_Event_Needs_RenderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Event_Needs_RenderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
});